export const CREATE_JOB_TYPE_MUTATION = `
  mutation CreateJobType($object: job_types_insert_input!) {
    insert_job_types_one(object: $object) {
      id
      name
      description
      status
      is_project_based
      status_group
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const UPDATE_JOB_TYPE_MUTATION = `
  mutation UpdateJobType($id: Int!, $set: job_types_set_input!) {
    update_job_types_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      name
      description
      status
      is_project_based
      status_group
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const DELETE_JOB_TYPE_MUTATION = `
  mutation DeleteJobType($id: Int!) {
    delete_job_types_by_pk(id: $id) {
      id
    }
  }
`;
